import { IUser } from "./User";
import { IReportingEntityWithDeliveryDates, ReportingEntityWithDeliveryDates } from "./ReportingEntity";
import { DayOfWeek } from '@fluentui/react';
import { ReportingFrequency } from "../refData/ReportingFrequency";

export interface IRiskMitigationAction extends IReportingEntityWithDeliveryDates {
    Description: string;
    RiskID: number | null;
    RiskMitigationActionCode: number | null;
    OwnerUserID: number | null;
    ActionIsOngoing: boolean;
    OngoingActionReviewFrequency: ReportingFrequency | null;
    OngoingActionReviewDueDay: DayOfWeek | null;
    OngoingActionReviewStartDate: Date | null;
    NextReviewDate?: Date;
    OwnerUser?: IUser;
}

export class RiskMitigationAction extends ReportingEntityWithDeliveryDates implements IRiskMitigationAction {
    public Description = '';
    public RiskID = null;
    public RiskMitigationActionCode = null;
    public OwnerUserID = null;
    public ActionIsOngoing = false;
    public OngoingActionReviewFrequency = null;
    public OngoingActionReviewDueDay = null;
    public OngoingActionReviewStartDate = null;
    public Contributors = [];
}
